import React, { useContext, useEffect, useState, useCallback } from "react";
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Modal,
  notification,
  Select,
} from "antd";
import axios from "axios";
import GlobalContext from "../../utils/GlobalContext";
import mergeProps from "../../utils/MergeProps";
const { Option } = Select;

const TemplateForm = ({
  open,
  isEdit,
  currentTemplate,
  onFinish,
  onCancel,
}) => {
  const globals = useContext(GlobalContext);
  const [form] = Form.useForm();
  const [meeting_types, setMeetingTypes] = useState([]);
  const [departments, setDepartments] = useState([]);

  const fetchMeetingTypes = useCallback(async () => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 100));
      const response = await axios.get(
        `${globals.SERVICE_API_DB}/v1/list-meeting-types`,
        {
          headers: {
            "x-token": globals.token,
          },
        }
      );
      setMeetingTypes(response?.data?.data);
    } catch (error) {
      console.error("Error fetching meeting types", error.response);
      notification.error({
        message: "Error obteniendo tipos de reunión",
        placement: "bottomRight",
      });
    }
    // setLoadingClients(false);
  }, [globals.SERVICE_API_DB, globals.token]);

  const fetchDepartments = useCallback(async () => {
    try {
      // setLoadingClients(true);
      await new Promise((resolve) => setTimeout(resolve, 100));
      const response = await axios.get(
        `${globals.SERVICE_API_DB}/v1/list-departments`,
        {
          headers: {
            "x-token": globals.token,
          },
        }
      );
      setDepartments(response?.data?.data);
    } catch (error) {
      console.error("Error fetching departments:", error.response);
      notification.error({
        message: "Error obteniendo departamentos",
        placement: "bottomRight",
      });
    }
    // setLoadingClients(false);
  }, [globals.SERVICE_API_DB, globals.token]);

  useEffect(() => {
    if (isEdit) {
      form.setFieldsValue({
        name: currentTemplate.name,
        meetingTypesId: currentTemplate.meetingTypesId,
        departmentsId: currentTemplate.departmentsId,
        guests: (currentTemplate.guests) ? currentTemplate.guests.split(",") : [],
      });
    }
  }, [isEdit, currentTemplate, form, open]);

  useEffect(() => {
    fetchMeetingTypes();
    fetchDepartments();
  }, [
    fetchMeetingTypes,
    fetchDepartments,
  ]);

  const handleComplete = async (values) => {
    try {
      if (isEdit) {
        values.id = currentTemplate.id;
        if (values.guests === undefined || values.guests.length === 0) {
          values.guests = "";
        }
        else{
          values.guests = values.guests.join(",");
        }
        const response = await axios.put(
          `${globals.SERVICE_API_DB}/v1/update-template/${currentTemplate.id}`,
          values,
          {
            headers: {
              "x-token": globals.token,
            },
          }
        );
        if (response?.data?.status === 0) {
          currentTemplate = mergeProps(currentTemplate, response?.data?.data);
          onFinish({ status: "edited" });
        }
        form.resetFields();
        return;
      }
      console.log("values", values);
      if (values.guests === undefined || values.guests.length === 0) {
        values.guests = "";
      }
      else{
        values.guests = values.guests.join(",");
      }
      const response = await axios.post(
        `${globals.SERVICE_API_DB}/v1/create-template`,
        values,
        {
          headers: {
            "x-token": globals.token,
          },
        }
      );
      console.log("response", response.data);
      onFinish({ status: "created", newTemplate: response?.data?.data });
      form.resetFields();
    } catch (error) {
      console.error("Error submitting form:", error.response);
      notification.error({
        message: "Error guardando plantilla",
        placement: "bottomRight",
      });
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  const filterMeetingTypeOption = (input, option) =>
    (option?.children ?? "").toLowerCase().includes(input.toLowerCase());

  const filterDepartmentsOption = (input, option) =>
    (option?.children ?? "").toLowerCase().includes(input.toLowerCase());

  const validatorEmpty = (rule, value) => {
    if (value && value.trim() === "") {
      return Promise.reject("Este campo es requerido");
    }
    return Promise.resolve();
  }

  
  return (
    <Modal
      title={isEdit ? "Editar plantilla" : "Crear plantilla"}
      open={open}
      onOk={handleCancel}
      onCancel={handleCancel}
      footer={null}
    >
      {/* <LoadingModal open={loading} /> */}
      <Form form={form} layout="vertical" onFinish={handleComplete}>
        <Form.Item
          name="name"
          label="Nombre de la plantilla"
          rules={[
            { required: true, message: "Este campo es requerido" },
            { validator: validatorEmpty }
          ]}
        >
          <Input />
        </Form.Item>
        <Row gutter={16}>
          <Col span={12}>
          <Form.Item
              name="departmentsId"
              label="Departamento"
              rules={[{ required: true, message: "Selecciona una opción" }]}
            >
              <Select
                showSearch
                placeholder="Selecciona una opción"
                filterOption={filterDepartmentsOption}
                optionFilterProp="children"
              >
                {departments.map((option) => (
                  <Option key={option.id} value={option.id}>
                    {option.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
          <Form.Item
              name="meetingTypesId"
              label="Tipo de reunión"
              rules={[{ required: true, message: "Selecciona una opción" }]}
            >
              <Select
                showSearch
                placeholder="Selecciona una opción"
                filterOption={filterMeetingTypeOption}
                optionFilterProp="children"
              >
                {meeting_types.map((option) => (
                  <Option key={option.id} value={option.id}>
                    {option.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        {/* <Form.Item name="guests" label="Invitados"  tooltip="Ingrese el correo electrónico de cada invitado y presione ENTER">
          <Select mode="tags" placeholder="Ingrese el correo electrónico de cada invitado"></Select>
        </Form.Item> */}
        <Row justify="end">
          <Col>
            <Button style={{ marginRight: 8 }} type="primary" htmlType="submit">
              {isEdit ? "Actualizar" : "Crear"}
            </Button>
            <Button style={{ marginRight: 8 }} onClick={handleCancel}>
              Cancelar
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default TemplateForm;
